import { render } from "./iconCurvaInscripcionGrande.vue?vue&type=template&id=8d10757a&scoped=true"
import script from "./iconCurvaInscripcionGrande.vue?vue&type=script&lang=js"
export * from "./iconCurvaInscripcionGrande.vue?vue&type=script&lang=js"

import "./iconCurvaInscripcionGrande.vue?vue&type=style&index=0&id=8d10757a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8d10757a"

export default script